
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { dispatchLogin, dispatchLogOut } from "@/store/dispatches";
@Component({
	name: "CenterHeader",
	components: {}
})
export default class CenterHeader extends Vue {
	@Getter("role") private role!: string;
	@Getter("save") private save!: string;
	@Getter("roleSave") private roleSave!: string;
	toHome() {
		this.$router.push({
			path: "/pcm/homePage"
		});
	}
	toSetting() {
		this.$router.push({
			path: `/${this.role}/setting`
		});
	}
	toSave() {
		this.$router.push({
			path: `/${this.role}/basic`
		});
	}
	toAuthern() {
		if (this.role === "apply") {
			return this.$message.warning("请登录企业账号进行实名认证!");
		}
		this.$router.push({
			path: `/${this.role}/authern`
		});
	}
	logOut() {
		this.$router.push({ path: "/login" });
		dispatchLogOut();
	}
}
